import {useAtom} from "jotai";
import userAtom from "../../atoms/userAtom";
import {HStack, Image} from "@chakra-ui/react";
import {MenuContent, MenuItem, MenuRoot, MenuTrigger} from ".././ui/menu";
import {Avatar} from ".././ui/avatar";
import {LuSettings, LuUser} from "react-icons/lu";
// import Logout from "./Logout";
import {Link} from "react-router-dom";

function DemoHeader() {
    const [user] = useAtom(userAtom);

    return (
        <HStack
            padding="10px"
            alignItems="center"
            justifyContent="space-between"
            className="agx__header"
            backgroundColor="#033642"
            zIndex="max"
        >
            {/* Logo now links to /dashboard */}
            {/*<Link to="/dashboard">*/}
            <Image
                height="40px"
                fit="contain"
                src="/logo.png"
                alt="Agxes - Agriculture risk assessment for lenders"
            />
            {/*</Link>*/}

            <MenuRoot variant="subtle">
                <MenuTrigger>
                    <Avatar name={`${user.name} ${user.lastName}`} src={user.img}/>
                </MenuTrigger>
                <MenuContent>
                    {/* "Ver perfil" now links to /profile */}
                    <MenuItem as={Link} to="/demo-profile" value="demo-profile">
                        My profile <LuUser/>
                    </MenuItem>
                    {user.role === "admin" && (<MenuItem as={Link} to="/settings" value="settings">
                        Settings <LuSettings/>
                    </MenuItem>)}
                    {/*<MenuItem as={Link} to="/settings" value="settings">*/}
                    {/*    Ajustes <LuSettings/>*/}
                    {/*</MenuItem>*/}
                    {/*<MenuItem value="logout">*/}
                    {/*    <Logout height="inherit" variant="plain" p={0}/>*/}
                    {/*</MenuItem>*/}
                </MenuContent>
            </MenuRoot>
        </HStack>
    );
}

export default DemoHeader;
